import { render, staticRenderFns } from "./BroadcastEmails.vue?vue&type=template&id=3ad0faf2&"
import script from "./BroadcastEmails.vue?vue&type=script&lang=js&"
export * from "./BroadcastEmails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports